import React, { useState, Fragment } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Media,
  Row,
  Collapse,
} from "reactstrap";
import { findMyPaysAsProperty } from "../../../../helpers/api/finance";
import useSWRFetchPagination from "../../../../helpers/hooks/useSWRFetchPagination";
import FalconCardHeader from "../../../common/FalconCardHeader";
import Calendar from "../../../common/Calendar";
import PageHeader from "../../../common/PageHeader";
import FullPagination from "../../../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import withRedirect from "../../../../helpers/hoc/withRedirect";
import Filter from "../../../common/Filter";
import { Message, PreloadState } from "../../../UI/preloading/PreloadState";
import { isIterableArray } from "../../../../helpers/utils";
import { faInfoCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import SupportLink from "../../support/components/SupportLink";
import IndicatorsPaymentsCurrentProperty from "./IndicatorsPaymentsCurrentProperty";
import ButtonIcon from "../../../common/ButtonIcon";

const IndicatorsPropertyPayments = () => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);
  const { property, id } = useParams();

  const [params, setParams] = useState({
    status: null,
    condominiumId: Number(id) || selectedCondominium,
    property_id: property,
    start_date: null,
    end_date: null,
  });

  const filter_options = [
    { value: 0, displayName: "Todos", disabled: false },
    { value: "pending", displayName: "Pendientes", disabled: false },
    { value: "approved", displayName: "Aprobados", disabled: false },
    { value: "refused", displayName: "Cancelados", disabled: false },
  ];

  const {
    data,
    isLoading,
    meta,
    handler: { goToPage, nextPage, perPage, previousPage },
  } = useSWRFetchPagination(findMyPaysAsProperty, params);

  const owner = data[0]?.property?.user?.data;

  const [collapseDetails, collapseDetailsOpen] = useState(false);

  const ButtonAdd = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Ver abonos de los propietarios
      </ButtonIcon>
    );
  };

  const ButtonAddP = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Ver pagos de los propietarios
      </ButtonIcon>
    );
  };

  const months = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  return (
    <Fragment>
      <PageHeader
        title="Pagos del propietario"
        titleTag="h2"
        className="mb-3"
        col={{ lg: 9 }}
      >
        <h4 className="mt-3">
          {owner?.firstname} {owner?.lastname}
        </h4>
        {role === "manager" && <SupportLink />}
        {collapseDetails === false ? (
          <div className="mt-3">
            <ButtonAdd
              onClick={() => {
                collapseDetailsOpen(!collapseDetails);
              }}
            />
          </div>
        ) : (
          <div className="mt-3">
            <ButtonAddP
              onClick={() => {
                collapseDetailsOpen(!collapseDetails);
              }}
            />
          </div>
        )}
      </PageHeader>
      <Collapse isOpen={collapseDetails}>
        <IndicatorsPaymentsCurrentProperty />
      </Collapse>
      <Collapse isOpen={!collapseDetails}>
        <Card>
          <FalconCardHeader title="Pagos realizados">
            <Row>
              <Col xs={12}>
                <Filter
                  keyField="status"
                  options={filter_options}
                  selectType={setParams}
                  dateFilter={true}
                />
              </Col>
            </Row>
          </FalconCardHeader>
          <CardBody className="fs--1 pt-0">
            <PreloadState cond={isIterableArray(data)} loading={isLoading}>
              {data.length > 0 ? (
                data.map((payment, i) => (
                  <Row
                    key={i}
                    className={
                      payment?.status === "pending"
                        ? "border-top py-3"
                        : payment?.status === "canceled"
                        ? "alert-danger border-top py-3"
                        : payment?.status === "refused"
                        ? "alert-danger border-top py-3"
                        : "alert-success border-top py-3"
                    }
                  >
                    <Col>
                      <Row>
                        <Col>
                          <Row>
                            <Col xs={12} className="d-flex align-items-center">
                              <Media>
                                <Calendar
                                  month={
                                    months[
                                      new Date(payment?.created_at).getMonth()
                                    ]
                                  }
                                  day={new Date(payment?.created_at).getDate()}
                                />
                                <Media
                                  body
                                  className="position-relative pl-3 align-self-center"
                                >
                                  <p className="mb-0">
                                    Pago mensual del propietario{" "}
                                    {payment?.property?.user?.data?.firstname}{" "}
                                    {payment?.property?.user?.data?.lastname}
                                  </p>
                                  <p className="fs--1 mb-0 font-weight-bolder">
                                    {payment?.status === "pending"
                                      ? "Pendiente"
                                      : payment?.status === "canceled"
                                      ? "Cancelado por propietario"
                                      : payment?.status === "refused"
                                      ? "Pago rechazado"
                                      : "Aprobado"}
                                  </p>
                                </Media>
                              </Media>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ))
              ) : (
                <Message
                  value={false}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  <>Aún no hay pagos para mostrar</>
                </Message>
              )}
            </PreloadState>
          </CardBody>
          <CardFooter>
            {isIterableArray(data) && (
              <FullPagination
                nextPage={nextPage}
                prevPage={previousPage}
                goToPage={goToPage}
                meta={meta}
                className={"shadow-none"}
                posText={"pagos"}
                perPage={perPage}
              />
            )}
          </CardFooter>
        </Card>
      </Collapse>
    </Fragment>
  );
};

export default withRedirect(IndicatorsPropertyPayments);
